'use strict';

import $ from 'jquery';

let FormHelpers = function ($el) {
    this.$el = $el;

    this.$billingName = $(this.$el).find('#fullBillingName');

    this.mTitle = this.$el.find("[name='mTitle']").val();
    this.mFirstName = this.$el.find("[name='mFirstName']").val();
    this.mLastName = this.$el.find("[name='mLastName']").val();

    if ($('#fullBillingName').length > 0) {

        let fullCardName = `${this.mTitle ? this.mTitle : ""} ${this.mFirstName ? this.mFirstName : ""} ${this.mLastName ? this.mLastName : ""}`;
        $('#fullBillingName').val(fullCardName.toUpperCase());
    }

    if($('#BermudaAddress').length > 0) {
        changeToBDA();
    }

    //billing address country selector
    $('#BermudaAddress').change(function() {
        changeToBDA();
    });
    console.log();

    //billing address country selector
    $('#UnitedStatesAddress').change(function() {
        changeToUSA()
    });

    if ($('#UnitedStatesAddress').is(':checked')){
        changeToUSA();
    }

    //billing address country selector
    $('#OtherAddress').change(function() {
        changeToOther()
    });

    if ($('#OtherAddress').is(':checked')) {
        changeToOther();
    }

    this.init();
};

function changeToBDA() {

    // hide others
    $('#streetAddress').show()//.attr('required', 'required');
    $('#street2Address').show()//.attr('required', 'required');
    $('#companyAddress').show()//.attr('required', 'required');
    $('#countryAddress').hide()//.attr('required', 'required');
    $('#parishAddress').show()//.attr('required', 'required');
    $('#parishAddressBDA').show()//.attr('required', 'required');
    $('#codeAddressOther').show()//.attr('required', 'required');
    $('#zipAddress').show()//.attr('required', 'required');
    $('#bcountry').val("BM");

    //set to Bermuda
    $('#cityAddress').hide();
    //$('#bcity').removeAttr('required');
    $('#stateAddress').hide()//.removeAttr('required');
    $('#parishAddressOther').hide()//.removeAttr('required');
    $('#codeAddressUS').hide()//.removeAttr('required');

}

function changeToUSA() {

    // hide others
    $('#streetAddress').show()//.attr('required', 'required');
    $('#street2Address').show()//.attr('required', 'required');
    $('#cityAddress').show()//.attr('required', 'required');
    $('#companyAddress').show()//.attr('required', 'required');
    $('#parishAddressOther').show()//.attr('required', 'required');
    $('#stateAddress').show()//.attr('required', 'required');
    $('#codeAddressUS').show()//.attr('required', 'required');
    $('#zipAddress').show()//.attr('required', 'required');
    $('#bcountry').val("US");

    $('#countryAddress').hide()//.removeAttr('required');
    $('#parishAddress').hide()//.removeAttr('required');
    $('#parishAddressBDA').hide()//.removeAttr('required');
    $('#codeAddressOther').hide()//.removeAttr('required');
}

function changeToOther() {

    // hide others
    $('#streetAddress').show()//.attr('required', 'required');
    $('#street2Address').show()//.attr('required', 'required');
    $('#cityAddress').show()//.attr('required', 'required');
    $('#companyAddress').show()//.attr('required', 'required');
    $('#parishAddressOther').show()//.attr('required', 'required');
    $('#codeAddressOther').show()//.attr('required', 'required');
    $('#countryAddress').show()//.attr('required', 'required');
    $('#parishAddress').show()//.attr('required', 'required');
    $('#zipAddress').show()//.attr('required', 'required');
    $('#bcountry').val("GB");

    $('#stateAddress').hide()//.removeAttr('required');
    $('#parishAddressBDA').hide()//.removeAttr('required');
    $('#codeAddressUS').hide()//.removeAttr('required');

}


FormHelpers.prototype.init = function () {

    /**
     * Register Event handlers here
     */

    $(this.$el).on('change', '#checkoutReason', (event) => {
        this.setExtraInfo(event);
    });

};

FormHelpers.prototype.setExtraInfo = function (event) {

    let $extra = $('#donationExtra');

    if ($(event.target).find(":selected").data('show-extra')) {
        $extra.parent().removeClass('d-none');
        $extra.parent().find('[for="donationExtra"]').text($(event.target).find(":selected").data('show-extra') + ' *');
        $extra.attr('required', 'required');
    } else {
        $extra.parent().addClass('d-none');
        $extra.removeAttr('required');
    }

};

FormHelpers.prototype.hideActionCaller = function (event) {
    $(event.currentTarget).addClass('d-none');
};

FormHelpers.init = function ($scope) {
    $($scope || '.form-helpers').each(function (i, el) {
        return new FormHelpers($(el));
    }.bind(this));
};

export default FormHelpers;